module.exports = __webpack_public_path__ + "static/media/hot.84422533.png";